import React, { useState, useEffect } from "react";
import BubbleChart from "react-tooltip-bubble-chart";

interface BubbleData {
  fillColor: string;
  id: number;
  name: string;
  size: number;
  dYdX1: { dy: number; dx: number };
}

interface BubbleChartProps {
  title: string;
  bubbleData: BubbleData[];
}

const BubbleChartComponent: React.FC<BubbleChartProps> = ({
  title,
  bubbleData,
}) => {
  const [chartWidth, setChartWidth] = useState(400);

  useEffect(() => {
    const updateWidth = () => {
      const screenWidth = window.innerWidth;
      if (screenWidth >= 1280) setChartWidth(500); // xl
      else if (screenWidth >= 1024) setChartWidth(400); // lg
      else setChartWidth(350); // default
    };

    updateWidth();
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);
  return (
    <div className="mx-auto p-6 bg-white rounded-md shadow-md">
      <div className="flex flex-wrap justify-center">
        <div
          className="flex flex-col items-start w-full p-1"
          style={{ height: "330px" }}
        >
          <h3 className="text-base font-bold text-custom-blue7 mb-2">
            {title}
          </h3>
          <div className="w-full h-0.5 bg-gray-300 mb-4"></div>
          <div className="flex flex-row items-center w-full">
            <div className="relative flex justify-center mx-auto w-full overflow-hidden">
              <BubbleChart
                bubblesData={bubbleData}
                width={chartWidth}
                height={272}
                textFillColor="#033570"
                backgroundColor="#fff"
                minValue={10}
                maxValue={200}
                move={true}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BubbleChartComponent;
